import {MuBinder} from "mu-widget/lib/MuBinder";
import {DateTime} from "mu-js-utils/lib/DateTime";
import {formatEnergy, formatWeight} from "./utils";

export const datetimeFormatAlias: Record<string, string> = {
    time: "H:i",
    times: "H:i:s",
};

export function registerFilters(muBinder: typeof MuBinder): void
{
    muBinder.filters = {
        ...muBinder.filters,
        formatDate: (d: Date, ev, format: string) =>
            DateTime.format(d, datetimeFormatAlias[format] ?? format),
        duration: (d: number) => formatDuration(d),
        dayTime: (d: number) => DateTime.secondsToInput(d, 'minute'),
        formatEnergy: (d: number, ev, addUnit: boolean = true) => formatEnergy(d, addUnit),
        formatWeight: (d: number, ev, addUnit: boolean = true) => formatWeight(d, addUnit),
        not: (d: boolean) => !d,
    }
}

export function formatDuration(d: number) {
    const parts = [];
    // parts.push((d % 60) + 's');
    if (d < 60) parts.push('<1m');
    d = Math.floor(d / 60);
    const m = d % 60;
    if (m > 0) parts.push(m + 'm');
    d = Math.floor(d / 60);
    if (d > 0) parts.push(d + 'h');

    return parts.reverse().join(' ');
}